<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><span class="bold">CONTENTS</span></h1>
<h2 class="toc"><span class="bold"><a href="#/xhtml/04_Introduction">Introduction</a></span></h2>
<h2 class="toc"><span class="bold"><a href="#/xhtml/05_Chapter1">Design &amp; Development</a></span></h2>
<h2 class="toc"><span class="bold"><span href="#/xhtml/06_Chapter2" title="Link target outside of Sample">Camouflage &amp; Markings</span></span></h2>
<h2 class="toc"><span class="bold"><span href="#/xhtml/07_Chapter3" title="Link target outside of Sample">In Service &amp; In Action</span></span></h2>
<h2 class="toc"><span class="bold"><span href="#/xhtml/08_Chapter4" title="Link target outside of Sample">B-17 Variants</span></span></h2>
<h2 class="toc"><span class="bold"><span href="#/xhtml/09_Chapter5" title="Link target outside of Sample">Modelling the B-17</span></span></h2>
<h2 class="toc"><span class="bold"><span href="#/xhtml/10_Chapter6" title="Link target outside of Sample">Showcase Models</span></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?3437abc5